"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddBricks = exports.CalcIncomePerSecond = exports.CalcBricksPerSecondFromBuilders = exports.CalcOfflineIncomeData = exports.CalcHouseReward = exports.CalcBricksPerClick = exports.CalcMoneyPerBrick = exports.CalcItemPrice = void 0;
var enums_1 = require("../enums");
var data_1 = require("../data");
var rendering_1 = require("../rendering");
var __1 = require("..");
var rewardedPopup_1 = require("../rewardedPopup");
var CalcItemPrice = function (item) {
    return Math.floor(data_1.Items[item].basePrice * Math.pow(data_1.Items[item].coefficient, data_1.GameData.itemLevel[item]));
};
exports.CalcItemPrice = CalcItemPrice;
var CalcMoneyPerBrick = function () {
    var mpb = data_1.GameData.itemLevel.moneyPerBrick + 1;
    if (rewardedPopup_1.PremiumIsActive) {
        mpb *= 2;
    }
    return mpb;
};
exports.CalcMoneyPerBrick = CalcMoneyPerBrick;
var CalcBricksPerClick = function () {
    var bpc = data_1.GameData.itemLevel.bricksPerClick + 1;
    if (rewardedPopup_1.PremiumIsActive) {
        bpc *= 2;
    }
    return bpc;
};
exports.CalcBricksPerClick = CalcBricksPerClick;
var CalcHouseReward = function () { return Math.floor((data_1.HouseData.totalBricks * (0, exports.CalcMoneyPerBrick)()) / 4); }; // 5 time less than all the money you earned building the house from bricks
exports.CalcHouseReward = CalcHouseReward;
var CalcOfflineIncomeData = function () {
    return {
        maxMoney: (0, exports.CalcItemPrice)(enums_1.ITEM.Bank) * 10,
        maxTimeMs: (data_1.GameData.itemLevel.banker + 1) * 30 * 60 * 1000, //every level adds 30 min
    };
};
exports.CalcOfflineIncomeData = CalcOfflineIncomeData;
var CalcBricksPerSecondFromBuilders = function () {
    var bricksPerSecond = 0;
    data_1.Builders.forEach(function (builder) {
        bricksPerSecond += data_1.GameData.itemLevel[builder] / data_1.Items[builder].intervalSeconds;
    });
    return bricksPerSecond;
};
exports.CalcBricksPerSecondFromBuilders = CalcBricksPerSecondFromBuilders;
var CalcIncomePerSecond = function () {
    return (0, exports.CalcBricksPerSecondFromBuilders)() * (0, exports.CalcMoneyPerBrick)();
};
exports.CalcIncomePerSecond = CalcIncomePerSecond;
var AddBricks = function (bricksToAdd) {
    // don't add bricks if house is full (to not give money), or add as many brick as required to finish the house
    if (data_1.GameData.placedBricks >= data_1.HouseData.totalBricks)
        return;
    if (data_1.GameData.placedBricks + bricksToAdd > data_1.HouseData.totalBricks) {
        bricksToAdd = data_1.HouseData.totalBricks - data_1.GameData.placedBricks;
    }
    data_1.GameData.placedBricks += bricksToAdd;
    data_1.GameData.money += bricksToAdd * (0, exports.CalcMoneyPerBrick)();
    (0, rendering_1.DrawRealBricks)();
    if (data_1.GameData.placedBricks >= data_1.HouseData.totalBricks)
        (0, __1.OnHouseBuilt)();
};
exports.AddBricks = AddBricks;
